import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class WindSpeedAttribute extends Sensor {
  public windSpeedChart: any;
  private windSpeedSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.windSpeedChart = null;
    this.windSpeedSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.windSpeedSensor, position);
      this.windSpeedSensor[position].push([timestamp, element.windSpeed]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredWindSpeed = this.windSpeedSensor.filter(series => series.length > 0);

    const positionNodeWindSpeed = this.windSpeedSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.windSpeedChart = this.getConfigChar(
      'windSpeed',
      this.getChartSeriesNewNode('Sensor', filteredWindSpeed, positionNodeWindSpeed),
      this.getRanges('windSpeed'),
      this.getLimits('windSpeed')
    );
  }

  public hasWindSpeedSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.windSpeedSensor.length &&
      this.windSpeedSensor[index].length > 0
    );
  }

  public getWindSpeedSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.windSpeedSensor.length) {
      const sensorData = this.windSpeedSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Velocidad del Viento', value: 'windSpeed' }
    ];
  }
}
